import apiClient from '../services/apiClient';
import { useQuery } from '@tanstack/react-query';
import { ICompany } from '../interfaces';

export function useCompaniesQuery(include_subs: boolean = false) {
	async function getCompanies() {
		const { data } = await apiClient.get(`/ref/companies`, {
			params: { include_subs },
		});
		return data;
	}
	return useQuery<ICompany[]>(['companies', include_subs], () => getCompanies());
}
